import { render } from "./coursesList.vue?vue&type=template&id=b9f02d66"
import script from "./coursesList.vue?vue&type=script&lang=js"
export * from "./coursesList.vue?vue&type=script&lang=js"

import "./coursesList.vue?vue&type=style&index=0&id=b9f02d66&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__